export const SetAchievementsActionType = 'SET_ACHIEVEMENTS';
export const setAchievements = achievements => ({
  type: SetAchievementsActionType,
  achievements
});

export const setAchievementsAndMarkAsAcknowledged =
  achievements => async (dispatch, getState) => {
    dispatch(setAchievements(achievements));
  };

export const DismissCompletedAchievementType = 'DISMISS_ACHIEVEMENT';
export const dismissCompletedAchievement = achievementId => ({
  type: DismissCompletedAchievementType,
  achievementIds: [achievementId]
});
export const dismissCompletedAchievements = achievementIds => ({
  type: DismissCompletedAchievementType,
  achievementIds
});
